import { render, staticRenderFns } from "./RiderDisciplineEdit.vue?vue&type=template&id=2a49edb7&lang=pug"
import script from "./RiderDisciplineEdit.vue?vue&type=script&lang=js"
export * from "./RiderDisciplineEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports